import { memo } from "react";

interface PinDotsProps {
  length: number;
  maxLength?: number;
}

/**
 * Memoized PIN dots indicator for the kiosk screen.
 * Extracted from KioskPage to prevent full-page re-renders on each key press.
 * Visual classes are identical to the original inline dots.
 */
export const PinDots = memo(({ length, maxLength = 6 }: PinDotsProps) => (
  <div className="flex justify-center space-x-4 py-4">
    {Array.from({ length: maxLength }).map((_, i) => {
      const hasValue = length > i;
      return (
        <div
          key={i}
          className={`w-5 h-5 rounded-full border-2 kiosk-pin-dot-transition ${
            hasValue
              ? 'bg-indigo-500 border-indigo-500 scale-110 shadow-lg shadow-indigo-500/30'
              : 'bg-transparent border-slate-700'
          }`}
        />
      );
    })}
  </div>
));
PinDots.displayName = 'PinDots';
